export const UNSPLASH_ACCESS_KEY =
  "C5QENfSRlHa4vsdqhgSBEEO1mI-IuKbA8H0EdyndSt4";
export const API_BASE = "/api/v1";
